<template>
  <div class="card border-0 card-with-shadow">
    <div class="card-header bg-transparent p-primary">
      <div class="row">
        <div class="col-8">
          <h5 v-show="isPeopleAndJobTitleEditable" class="card-title text-muted m-0">{{
              $t('organizations_and_job_title')
            }}</h5>
          <h5 v-show="!isPeopleAndJobTitleEditable" class="card-title text-muted m-0">{{
              $t('edit_organizations_and_job_title')
            }}</h5>
        </div>
        <div class="col-4">
          <div class="d-flex align-items-center justify-content-end h-100">
            <a href="#" v-show="!isPeopleAndJobTitleEditable" class="text-muted"
               @click.prevent="showPeopleAndJobTitlePeopleJobHide">
              <app-icon stroke-width="1" name="x-square"/>
            </a>
            <a href="#" v-show="!isPeopleAndJobTitleEditable" class="text-muted"
               @click.prevent="showPeopleAndJobTitleSave">
              <app-icon stroke-width="1" name="check-square"/>
            </a>

            <a href="#" v-show="isPeopleAndJobTitleEditable" class="text-muted"
               @click.prevent="showPeopleAndJobTitleEditable">
              <app-icon stroke-width="1" name="edit"/>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="demoData" class="card-body">
      <div v-show="isPeopleAndJobTitleEditable">
        <template v-if="demoData.length">
          <div class="d-flex justify-content-between align-items-center"
               :class="{'mb-3': demoData.length > 1 && indexOne !== demoData.length - 1}"
               v-for="(organization, indexOne) in demoData"
               :key="indexOne">
            <div class="media d-flex align-items-center">
              <app-avatar
                  :title="organization.name"
                  class="mr-2"
                  avatar-class="avatars-w-40"
                  :img="organization.profile_picture ?
                            urlGenerator(organization.profile_picture.path) :
                            organization.profile_picture"
              />
              <div class="media-body">
                {{ organization.name }}
                <p class="text-muted font-size-90 mb-0">
                                <span v-if="organization.pivot !== ''">
                                    {{ organization.pivot.job_title }}
                                </span>
                  <span v-else>
                                    {{ $t('no_job_title_here') }}
                                </span>
                </p>
              </div>
            </div>
            <template v-if="organization.contact_type">
              <app-badge :label="organization.contact_type.name"
                         :className="`badge-sm badge-pill badge-${organization.contact_type.class}`"/>

            </template>

          </div>
        </template>
        <template v-else>
          <p class="text-muted">{{ $t('no_organization_linked_yet') }}</p>
          <a href="#" class="font-size-90" @click.prevent="showPeopleAndJobTitleEditable">
            {{ $t('link_an_organization') }}
          </a>
        </template>
      </div>

      <div v-show="!isPeopleAndJobTitleEditable">
        <div class="form-group"
             :class="{'mb-3': demoData.length > 1 && indexTwo !== demoData.length - 1}"
             v-for="(organization, indexTwo) in demoData"
             :key="indexTwo">
          <div class="form-row align-items-center">
            <div class="col-12 mb-1">
              <app-input type="select"
                         list-value-field='name'
                         :list="organizationList"
                         :placeholder="$t('choose_one')"
                         v-model="organization.pivot.organization_id"/>

            </div>
            <small class="text-danger" v-if="Object.keys(errors).length">
              <template v-for="validate in Object.keys(errors)">
                <template v-if="validate.slice(0, -16) == indexTwo">
                  <template v-for="messageData in errors[validate]">{{ messageData }}</template>
                </template>
              </template>
            </small>
            <div class="col-10">
              <app-input type="text"
                         :placeholder="$t('type_job_title')"
                         v-model="organization.pivot.job_title"/>
            </div>
            <div class="col-2 d-flex justify-content-center">
              <a href="#" class="text-muted" @click.prevent="removePeople(indexTwo)">
                <app-icon width="20" stroke-width="1" name="trash"/>
              </a>
            </div>
          </div>
        </div>
        <a href="#" @click.prevent="addMorePeople">
          {{ $t('add_more') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {urlGenerator} from "@app/Helpers/helpers";

export default {
  name: "OrganizationJob",
  props: ['organizationJob', 'person'],
  mixins: [FormMixin],
  data() {
    return {
      urlGenerator,
      isPeopleAndJobTitleEditable: true,
      formData: {},
      demoData: this.organizationJob,
      errors: [],
    }
  },
  computed: {
    organizationList() {
      let organizations = this.$store.getters.getOrganization
      let check = organizations.find((item) => {
        return item.id == ''
      });
      if (check == undefined)
        organizations.unshift({
          id: "",
          disabled: true,
          name: this.$t('choose_one'),
        });
      return organizations;
    },
  },

  methods: {
    addMorePeople() {
      this.demoData.push({
        pivot: {
          organization_id: '',
          job_title: ''
        }
      });
    },
    removePeople(indexTwo) {
      this.demoData.splice(indexTwo, 1)
    },
    showPeopleAndJobTitleEditable() {
      this.isPeopleAndJobTitleEditable = false;
    },
    showPeopleAndJobTitlePeopleJobHide() {
      let organizationJobList = this.demoData.filter((item) => item['id'] != undefined)
      this.demoData = organizationJobList;
      this.isPeopleAndJobTitleEditable = true;
    },
    showPeopleAndJobTitleSave() {
      this.formData = this.demoData.map((v, i) => {
        return {
          'organization_id': parseInt(v.pivot.organization_id),
          'job_title': v.pivot.job_title
        }
      });
      let arr = this.demoData.map((data)=> parseInt(data.pivot.organization_id));
      if(new Set(arr).size == arr.length){
        this.axiosPost({
          url: `crm/persons/organizations/sync/${this.person}`,
          data: this.formData
        }).then(response => {
          this.errors = [];
          this.$toastr.s(response.data.message);
          this.isPeopleAndJobTitleEditable = true
          this.$emit('update-request')
        }).catch((error) => {
          this.errors = error.response.data.errors;
        })
      }else{
        this.$toastr.i(this.$t('organization_duplicate'),'Duplicate');
      }
    },

  },
}
</script>